import { render, staticRenderFns } from "./chat22.vue?vue&type=template&id=1abdd611"
import script from "./chat22.vue?vue&type=script&lang=js"
export * from "./chat22.vue?vue&type=script&lang=js"
import style0 from "./chat22.vue?vue&type=style&index=0&id=1abdd611&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports